export default __webpack_public_path__ + "static/media/logo-written.d8597e11.svg";